import { Star } from "lucide-react";

/**
 * ReviewCard — a Google-styled review card. Works whether the review
 * came from the CMS (source='manual') or from a future Google Places
 * API pull (source='google'). Structurally identical.
 */
const ReviewCard = ({ review }) => {
  const stars = Math.max(0, Math.min(5, review.rating || 5));
  const initials = (review.author_name || "")
    .split(" ")
    .map((s) => s[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

  return (
    <article className="rounded-2xl border border-border p-6 bg-card" data-testid={`review-card-${review.author_name?.replace(/\s/g,'-').toLowerCase()}`}>
      <header className="flex items-center gap-3">
        {review.profile_photo_url ? (
          <img
            src={review.profile_photo_url}
            alt={review.author_name}
            loading="lazy"
            className="w-10 h-10 rounded-full object-cover border border-border"
          />
        ) : (
          <div className="w-10 h-10 rounded-full bg-[hsl(var(--secondary))] text-[hsl(var(--foreground))]/80 grid place-content-center text-sm font-semibold">
            {initials || "•"}
          </div>
        )}
        <div className="flex-1 min-w-0">
          <div className="font-medium truncate">{review.author_name}</div>
          <div className="text-[11px] uppercase tracking-[0.18em] text-muted-foreground">
            {review.relative_time || ""}
          </div>
        </div>
        {review.source === "google" && (
          <span className="text-[10px] uppercase tracking-[0.22em] text-[hsl(var(--accent))]" title="From Google">
            G
          </span>
        )}
      </header>
      <div className="mt-3 flex gap-0.5" aria-label={`${stars} out of 5 stars`}>
        {Array.from({ length: 5 }, (_, i) => (
          <Star
            key={i}
            size={14}
            className={i < stars ? "fill-[hsl(var(--accent))] text-[hsl(var(--accent))]" : "text-border"}
          />
        ))}
      </div>
      <p className="mt-3 text-sm text-[hsl(var(--foreground))]/80 leading-relaxed">{review.text}</p>
    </article>
  );
};

export default ReviewCard;
